export default "__VITE_PUBLIC_ASSET__1031af05__"